export function isFunction(val) {
  return typeof val === 'function';
}
export const isNumber = value => typeof value === 'number' && !isNaN(value);
export const isNil = value => value == null;
const htmlRegex = new RegExp(/^<\/?[a-z][\s\S]*>/, 'i');
export const isHtml = value => {
  return typeof value === 'string' && htmlRegex.test(value);
}; // if you have a array with narrow type i.e. that can only have limited values
// .includes function on that array doesn't accept any string, but one of the narrow types
// The function below is to check if a string is present in narrow typed array
// For more info see – https://fettblog.eu/typescript-array-includes/

export function includedInReadOnlyArray(coll, el) {
  return coll.includes(el);
}